<script setup lang="ts">
import { onBeforeUnmount, onMounted, watch } from "vue";
import AppHeader from "@/components/AppHeader.vue";
import AppsPanel from "@/components/AppsPanel.vue";
import ClientPanel from "@/components/ClientPanel.vue";
import EventLog from "@/components/EventLog.vue";
import LoginView from "@/components/LoginView.vue";
import ScreenTimePanel from "@/components/ScreenTimePanel.vue";
import ToastStack from "@/components/ToastStack.vue";
import TrendPanel from "@/components/TrendPanel.vue";
import { auth, refreshSession } from "@/stores/auth";
import { dashboard, startDashboard, stopDashboard } from "@/stores/dashboard";

onMounted(refreshSession);
onBeforeUnmount(stopDashboard);

// Der Live-Feed laeuft nur mit gueltiger Sitzung - /dashboard-ws verlangt Anmeldung.
watch(
  () => auth.isAuthenticated,
  (authenticated) => (authenticated ? startDashboard() : stopDashboard()),
  { immediate: true },
);
</script>

<template>
  <template v-if="auth.checked">
    <LoginView v-if="!auth.isAuthenticated" />

    <template v-else>
      <AppHeader :connection="dashboard.connection" :last-update="dashboard.lastUpdate" />
      <main>
        <ScreenTimePanel :entries="dashboard.screenTime" />
        <AppsPanel />
        <TrendPanel />
        <ClientPanel :clients="dashboard.clients" />
        <EventLog :events="dashboard.events" />
      </main>
    </template>
  </template>

  <ToastStack />
</template>

<style scoped>
main {
  padding: 20px;
  display: grid;
  gap: 24px;
  max-width: 1100px;
  margin: 0 auto;
}
</style>
